import { Ripple } from '@components/ui/shadcn-io/ripple';
import { cn } from '@lib/utils';

const BUTTERFLY_GIF_SRC = '/assets/gifs/butterfly.gif';

interface LoadingScreenProps {
  message?: string;
  isFullPage?: boolean;
}

export function LoadingScreen({ message = 'Weaving your silk story...', isFullPage = false }: LoadingScreenProps) {
  return (
    <div
      className={cn(
        'text-primary-foreground relative flex w-full items-center justify-center overflow-hidden rounded-xl p-8',
        isFullPage ? 'min-h-screen' : 'min-h-[60vh]'
      )}
      role="status"
      aria-live="polite"
      style={{
        background:
          'radial-gradient(circle at 15% 20%, color-mix(in srgb, var(--color-secondary) 40%, transparent) 0%, var(--color-primary) 55%, color-mix(in srgb, var(--color-background) 85%, transparent) 110%)',
      }}
    >
      <Ripple aria-hidden="true" className="text-primary-foreground/30" numCircles={9} mainCircleSize={260} />
      <div className="relative z-10 flex flex-col items-center gap-4 text-center">
        <div className="bg-background/80 relative flex h-40 w-40 items-center justify-center rounded-full shadow-inner backdrop-blur">
          <img
            src={BUTTERFLY_GIF_SRC}
            alt="Butterfly weaving animation"
            className="h-28 w-28 object-contain drop-shadow-lg"
            loading="eager"
            decoding="async"
            width={112}
            height={112}
          />
        </div>
        <p className="text-primary-foreground/70 text-xs font-semibold tracking-[0.6em] uppercase">Sree Silks</p>
        <p className="text-primary-foreground/80 max-w-sm text-sm sm:text-base">{message}</p>
      </div>
    </div>
  );
}
